<template>
    <station-error-list/>
</template>

<script>
import StationErrorList from "@/components/sensor/StationErrorList";
import {mapActions, mapState} from "vuex";
import {PermissionsConstants} from "@/permissions";

export default {
    name: "SensorErrorList",
    components: {
        'station-error-list': StationErrorList
    },

    mounted() {
        if (this.loggedIn && (!['super_admin'].includes(this.user?.role) || (this.user?.user_permissions?.error_logs?.length === 0 || !this.user?.user_permissions?.error_logs?.includes(PermissionsConstants.VIEW)))) {
            this.logOut()
        }
    },

    computed: {
        ...mapState('auth', ['user']),
    },

    methods: {
        ...mapActions('auth', ['logOut']),
    }
}
</script>

<style scoped>

</style>